import styled from '@emotion/styled';

export const FormError = styled.div(({ theme }) => ({
  color: theme.color.error,
  fontSize: theme.fontSize.sm,
}));
